// eventBus.js

import Vue from 'vue';

// 创建一个独立的 Vue 实例作为事件总线
const noticeBus = new Vue();

export default noticeBus;
